import { useMutation } from '@tanstack/react-query';
import { handleErrorResponse } from '../../utils/handleError';
import { AxiosError } from 'axios';
import { updateHeathSurvey } from '../../apis/survey';
import { useNavigate } from 'react-router-dom';
import queryClient from '../../lib/queryClient';

const useUpdateFeelingSurvey = () => {
  const navigate = useNavigate();
  const { mutate, error, isPending, status, isError, isSuccess } = useMutation({
    mutationKey: ['profile'],
    mutationFn: updateHeathSurvey,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['health-status', variables?.patientId, variables?.date],
      });
      queryClient.invalidateQueries({
        queryKey: ['health-survey', variables?.patientId],
      });
      navigate('/survey/track');
    },
    onError: (error: AxiosError) => {
      handleErrorResponse(error, 'Something went wrong');
    },
  });
  return {
    mutate,
    isError,
    isSuccess,
    error,
    isPending,
    status,
  };
};

export default useUpdateFeelingSurvey;
